var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeller(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37914E"
    },
    points: "247.172,450.207 176.551,450.207 211.8,388.414  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4FBA6F"
    },
    points: "158.896,512 176.551,450.207 247.172,450.207 264.827,512  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48A0DC"
    },
    d: "M512,141.241C512,63.232,448.768,0,370.758,0S229.517,63.232,229.517,141.241 s63.232,141.241,141.241,141.241S512,219.251,512,141.241"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E64C3C"
    },
    d: "M17.798,422.666C6.86,428.421,0.001,439.809,0.001,452.167v59.833h158.897l17.655-61.793 l-45.506-68.996C95.966,385.493,57.901,401.559,17.798,422.666"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4FBA6F"
    },
    d: "M134.46,338.82l-10.302,31.938l52.392,79.448l35.31-61.793 C181.272,388.413,153.792,367.845,134.46,338.82"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E64C3C"
    },
    d: "M405.926,422.666c10.937,5.756,17.796,17.143,17.796,29.502v59.833H264.825l-17.655-61.793 l45.506-68.996C327.757,385.493,365.822,401.559,405.926,422.666"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4FBA6F"
    },
    d: "M289.264,338.82l10.302,31.938l-52.392,79.448l-35.31-61.793 C242.451,388.413,269.931,367.845,289.264,338.82"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC794"
    },
    d: "M229.517,141.241c0-17.346,3.275-33.88,8.995-49.231c-8.527-2.348-17.426-3.734-26.65-3.734 c-58.5,0-105.931,50.388-105.931,112.552v46.345c0,66.304,47.431,141.241,105.931,141.241c51.456,0,94.305-57.971,103.892-117.045 C265.074,249.927,229.517,199.733,229.517,141.241"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M371.805,209.767c4.74,4.749,10.002,8.995,15.881,12.235c19.747,10.858,40.104,11.246,58.809-7.459 l8.625-8.625c4.149-4.149,5.102-10.522,2.357-15.713c-6.453-12.191-30.252-26.138-30.252-26.138 c-5.385-3.072-11.882-3.416-14.954,2.057c0,0-7.733,9.278-9.693,10.611c-8.986,6.082-17.311,5.853-25.715-2.551l-19.518-19.527 l-19.527-19.527c-8.404-8.395-8.642-16.719-2.551-25.706c1.333-1.969,10.611-9.702,10.611-9.702 c5.464-3.072,5.129-9.569,2.057-14.954c0,0-13.948-23.799-26.147-30.252c-5.182-2.745-11.555-1.783-15.704,2.366l-8.625,8.625 c-17.32,17.32-18.273,36.052-9.702,54.404c3.478,7.442,8.501,14.062,14.301,19.88L371.805,209.767z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeller);
export default __webpack_public_path__ + "static/media/seller.0ea5eb924a04aca1458d9098f65e5216.svg";
export { ForwardRef as ReactComponent };